module.exports = __webpack_public_path__ + "r-v3/img/video-del.11d971a0.svg";